import React from 'react';
import Navigation from '../_components/Navigation';
import UserPreferencesEditForm from '../_components/UserPreferencesEditForm';
import { withAuthenticatedUser } from 'Components/withAuthenticatedUser';
import { withRouter } from 'Components/withRouter';
import { userService, jobService } from '../_services';
import styles from './UserPreferencesPage.module.css';

class UserPreferencesPage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            printLabelFormats: null,
            userPreferences: null
        };

        this.onSubmit = this.onSubmit.bind(this);
        this.onCancel = this.onCancel.bind(this);
    }

    componentDidMount() {
        jobService.getPrintLabelFormats()
            .then(printLabelFormats => {
                this.setState({
                    printLabelFormats
                });
            })
            .catch(error => {
                console.log(error)
            });
        userService.getUserPreferences()
            .then(preferences => {
                this.setState({
                    userPreferences: preferences
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    onSubmit(event, preferences) {
        userService.submitUserPreferences(preferences.defaultPrintLabelFormat)
            .then((response) => {

                alert(response || 'Saved');

                if (this.props.router.navigate) {
                    var url = `/user_preferences`;
                    this.props.router.navigate(url, { replace: true });
                }
                
            })
            .catch(error => {
                console.log(error);
            });
    }

    onCancel(event){
        if (this.props.router.navigate) {
            this.props.router.navigate(-1);
        }
    }

    render () {
        return (
            <div id="user-preferences">
                <Navigation authenticatedUser={this.props.authenticatedUser} />
                <div className="container-fluid padding-lr55 bg-form flat">
                    <div className="row">
                        <div className="col-xs-12 col-sm-6">
                            <div className="row h3">
                                <div className="col-xs-12">User Preferences</div>
                            </div>
                        </div>
                    </div>
                    <div className="padding-tb10" />
                    <div className="row">
                        <div className="col-sm-12">
                            {this.state.printLabelFormats && this.state.userPreferences &&
                                <UserPreferencesEditForm
                                    printLabelFormats={this.state.printLabelFormats}
                                    userPreferences={this.state.userPreferences}
                                    onSubmit={this.onSubmit}
                                    onCancel={this.onCancel}
                                    />
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const AuthenticatedUserPreferencesPage = withAuthenticatedUser(withRouter(UserPreferencesPage));

export { AuthenticatedUserPreferencesPage as UserPreferencesPage };